export function formatEUR(amount, opts = {}) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: opts.decimals ?? 0,
    minimumFractionDigits: opts.decimals ?? 0,
  }).format(n);
}

export function formatEURDec(amount) {
  return formatEUR(amount, { decimals: 2 });
}

export function formatDate(iso, opts = {}) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (opts.withTime) {
      return d.toISOString().replace("T", " ").slice(0, 16) + "Z";
    }
    return d.toISOString().slice(0, 10);
  } catch {
    return String(iso);
  }
}

export function relativeTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "or ora";
  if (diff < 3600) return `${Math.floor(diff / 60)}m fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h fa`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}g fa`;
  return d.toISOString().slice(0, 10);
}

export const STATUS_STYLES = {
  NEW: "text-[#EDEDED] border-[#EDEDED]",
  QUOTED: "text-[#0055FF] border-[#0055FF]",
  PRD_READY: "text-[#0055FF] border-[#0055FF]",
  QUOTED_AND_PRD: "text-[#F5A623] border-[#F5A623]",
  SENT: "text-[#0055FF] border-[#0055FF]",
  DRAFT: "text-neutral-400 border-neutral-600",
  APPROVED: "text-[#EDEDED] border-[#EDEDED]",
  ACTIVE: "text-[#EDEDED] border-[#EDEDED]",
  IN_PROGRESS: "text-[#0055FF] border-[#0055FF]",
  PLANNING: "text-neutral-400 border-neutral-600",
  OPEN: "text-[#EDEDED] border-[#EDEDED]",
  BLOCKED: "text-[#F5A623] border-[#F5A623]",
  UP: "text-[#4ADE80] border-[#4ADE80]",
  DEGRADED: "text-[#F5A623] border-[#F5A623]",
  DOWN: "text-red-400 border-red-500",
};

export function statusClass(status) {
  return STATUS_STYLES[status] || "text-neutral-400 border-neutral-700";
}

// Semantic palette — used by Dashboard event feed & Memograph badges.
// Returns { className, label } given an event kind string like "lead.created".
export function kindStyle(kind) {
  if (!kind) return { className: "k-system", label: kind || "—" };
  const prefix = kind.split(".")[0];
  const MAP = {
    lead: "k-lead",
    quote: "k-quote",
    prd: "k-prd",
    decision: "k-decision",
    loop: "k-loop",
    agent: "k-agent",
    system: "k-system",
    memograph: "k-memograph",
  };
  return { className: MAP[prefix] || "k-system", label: kind };
}

// Priority palette — used for loop pills.
export function priorityStyle(p) {
  const MAP = { P0: "p-P0", P1: "p-P1", P2: "p-P2" };
  return MAP[p] || "text-neutral-500 border-neutral-700";
}

// KPI stripe color — used for the accented top border on Dashboard KPI cards.
export const KPI_STRIPE = {
  clients: "#22D3EE",
  quotes: "#F5A623",
  projects: "#4ADE80",
  agents_ok: "#4ADE80",
  agents_warn: "#EF4444",
};
